import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const fetchVisitsForWebCalendar = async (profileId, value, setError, saveVisits, logoutHandler) => {
  const payload = { start_date: value.start, end_date: value.end };
  await apiCaller
    .get(`${URLS.VISITS_WEB_CALENDAR_BY_WORKSHOP_PROFILE}${profileId}/`, {
      params: payload,
    })
    .then((response) => {
      if (response.data !== undefined) {
        saveVisits(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400TextRead);
      }
      setError(STRINGS.common.error404Text);
    });
};

export default fetchVisitsForWebCalendar;
